import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  MenuItem,
  Select,
} from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";
import Subscription from "../../../licensing/Models/Subscription";
import { useDialog } from "../../../licensing/utils/DialogProvider";
import ControlledInput from "../../../components/CustomInput/ControlledInput";
import SubsSubscriptionAdditional, {
  OrderStatus,
  StatusInvoicing,
  Type,
} from "../../../licensing/Models/SubsSubscriptionAdditional";
import * as actions from "../../../store/actions";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";

function NewAdditionalInvoiceLine(props) {
  const [newSubsSubscriptionAdditional, setNewSubsSubscriptionAdditional] = useState(null);
  const [saving, setSaving] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [, closeDialog] = useDialog();

  useEffect(() => {
    if (props.subscriptionId) {
      Subscription.get(props.subscriptionId).then(({ model }) => {
        setSubscription(model);
        setNewSubsSubscriptionAdditional(
          new SubsSubscriptionAdditional(
            0,
            props.subscriptionId,
            [],
            new Date(),
            0,
            Type.ORDERS,
            OrderStatus.BOTH,
            "",
            StatusInvoicing.ACTIVE,
            "",
            new Date(),
            new Date(),
            null
          )
        );
      });
    }
  }, []);
  return (
    <>
      <DialogTitle>New additional item to be invoiced</DialogTitle>
      <DialogContent style={{ minHeight: 400 }}>
        {newSubsSubscriptionAdditional == null ? <CircularProgress /> : null}
        {newSubsSubscriptionAdditional != null ? (
          <GridContainer>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Type"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  newSubsSubscriptionAdditional.type = e.target.value;
                  setNewSubsSubscriptionAdditional(
                    Object.assign(Object.create(newSubsSubscriptionAdditional), newSubsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                value={newSubsSubscriptionAdditional.type}
              >
                {Object.keys(Type).map((type) => {
                  return <MenuItem value={type}>{type}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Orderstatus"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  newSubsSubscriptionAdditional.order_status = e.target.value;
                  setNewSubsSubscriptionAdditional(
                    Object.assign(Object.create(newSubsSubscriptionAdditional), newSubsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                value={newSubsSubscriptionAdditional.order_status}
              >
                {Object.keys(OrderStatus).map((order_status) => {
                  return <MenuItem value={order_status}>{order_status}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Active on salesareas"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <AsynchronousAutocomplete
                async={{
                  url: `core/vestigingen/search?fields=id,id as value,naam as label&sort_field=naam&sort_dir=asc`,
                  searchField: "naam",
                  perPage: 20,
                }}
                key={"selectSalesAreas"}
                multiple={true}
                onChange={(e, option) => {
                  let vList = [];
                  if (option && option.length > 0) {
                    /**
                     * Vol
                     */
                    option.forEach((item) => {
                      vList.push(item.value);
                    });
                  } else {
                    /**
                     * Leeg
                     */
                    vList = [];
                  }
                  newSubsSubscriptionAdditional.salesarea_ids = vList;
                  setNewSubsSubscriptionAdditional(
                    Object.assign(Object.create(newSubsSubscriptionAdditional), newSubsSubscriptionAdditional)
                  );
                }}
                placeholder={getTranslation("Search salesareas")}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Invoiceing status"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  newSubsSubscriptionAdditional.status_invoicing = e.target.value;
                  setNewSubsSubscriptionAdditional(
                    Object.assign(Object.create(newSubsSubscriptionAdditional), newSubsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                value={newSubsSubscriptionAdditional.status_invoicing}
              >
                {Object.keys(StatusInvoicing).map((status_invoicing) => {
                  return <MenuItem value={status_invoicing}>{status_invoicing}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Start date"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  newSubsSubscriptionAdditional.start_date = value;
                  setNewSubsSubscriptionAdditional(
                    Object.assign(Object.create(newSubsSubscriptionAdditional), newSubsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                type={"date"}
                value={newSubsSubscriptionAdditional.start_date}
              />
            </GridItem>
            <>
              <GridItem sm={4} xs={12}>
                <FormLabel>
                  <TranslationWrapper tKey={"Unit price"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={8} xs={12}>
                <ControlledInput
                  onHandleValue={(value) => {
                    newSubsSubscriptionAdditional.unit_price = value;
                    setNewSubsSubscriptionAdditional(
                      Object.assign(Object.create(newSubsSubscriptionAdditional), newSubsSubscriptionAdditional)
                    );
                  }}
                  style={{ width: "100%" }}
                  type={"currency"}
                  value={newSubsSubscriptionAdditional.unit_price}
                />
              </GridItem>
            </>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Notes"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  newSubsSubscriptionAdditional.notes = value;
                  setNewSubsSubscriptionAdditional(
                    Object.assign(Object.create(newSubsSubscriptionAdditional), newSubsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                type={"text"}
                value={newSubsSubscriptionAdditional.notes}
              />
            </GridItem>
          </GridContainer>
        ) : null}
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <SaveButton
          buttonText={<TranslationWrapper tDefault={"Opslaan"} tKey={"global.jamezzForm.savebutton.text"} />}
          disabled={subscription == null}
          hasError={hasError}
          onClick={() => {
            setSaving(true);
            newSubsSubscriptionAdditional
              .apiCreate()
              .then(() => {
                props.onSaved();
                closeDialog();
              })
              .catch(() => {
                setSaving(false);
                toast.error("Error");
              });
          }}
          saving={saving}
          type={"submit"}
        />
      </DialogActions>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(null, mapDispatchToProps)(NewAdditionalInvoiceLine);
